export const ALL = 'all';
export const SPECIFIC = 'specific';
export const DEFAULT_CALENDAR_TIME_ZONE = 'America/New_York';
export const EASTERN_TIME = 'Eastern Time';
export const EASTERN_TIME_ABBREVIATION = 'ET';
